import { create } from 'zustand';
import { readAppSettings, updateAppSettings } from '@/storage/settingsRepo';
import type { AppSettings } from '@/storage/types';

interface SettingsState extends AppSettings {
  update: (patch: Partial<AppSettings>) => void;
}

/** App-wide settings (F10.3), read synchronously at startup and saved on every change. */
export const useSettingsStore = create<SettingsState>()((set) => ({
  ...readAppSettings(),
  update(patch) {
    set(patch);
    void updateAppSettings(patch);
  },
}));
